import { render, staticRenderFns } from "./ExpandCollapse.vue?vue&type=template&id=04c1bddb&scoped=true&"
import script from "./ExpandCollapse.vue?vue&type=script&lang=js&"
export * from "./ExpandCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ExpandCollapse.vue?vue&type=style&index=0&id=04c1bddb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1bddb",
  null
  
)

export default component.exports